<template>

  <t-page>

    <t-page-form :title="'Formulário de '+title">



    </t-page-form>

  </t-page>

</template>
<script>
//import {crud} from "@/services/modules/product/Classes.service";
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"

//pageFormMixin.setServiceCRUD(crud);

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'ProductsClasses',
  data() {
    return {
      title: "Família de Produtos",
      command: 'insert',
      formDefault: {
        name: "formDefault",
        state: "pending"
      },

    }
  },
  methods: {

    onSubmit() {


      //Adiciona erros em um campo específico.
      //console.log(this.$refs.formDefault.$children)


      /* this.$refs.formDefault.setErrors({
         //name: ['Validação em tempo de execução com atribuição de nome e envio']
       });*/

      // Código que reseta validação
      /* this.$nextTick(() => {
        this.$refs.formDefault.reset();
      });*/

      this.$refs.formDefault.validate().then(success => {

        if (!success) {
          return;
        }

        alert('Form has been submitted!');


        console.log('Form enviado' + JSON.stringify(this.form))


      });


    },

  },
  mounted() {

     //Via API deverá obter os dados de forma assincrona no padrão a seguir
    this.form = {
      name: "Teste"
    }},


  computed: {},

}
</script>
